import ProductCard from '../components/ProductCard.js';
import '../styles/ProductCard.css';
import { projects } from '../assets/projects.js';

const Properties = () =>{

    return(
        <>
        <title>Zuri Lands Investment Limited - Projects</title>
        <div className="banner">
          <h2>Our Projects</h2>
        </div>
        <div className="product-grid-container">
            <div className="product-grid">
                {projects.map((product, index) => (
                    <ProductCard key={index} product={product} />
                ))}
            </div>
        </div>

        </>
    );

};

export default Properties;